export const getMainAccountCheckboxes = (): HTMLInputElement[] => {
  return Array.from(
    document.querySelectorAll<HTMLInputElement>(
      '[data-behaviour="ledger-copier-account-selector"]'
    )
  )
}

export const getReconciliationWrappers = (): HTMLElement[] => {
  return Array.from(
    document.querySelectorAll<HTMLElement>(
      '[data-behaviour~="ledger-copier-reconciliation-selector"]'
    )
  )
}
